import { debug } from './utils.js';

function mountComponent(component) {
  if (component instanceof Promise) {
    component.then(function (instance) {
      return instance.$mount();
    });
  } else {
    component.$mount();
  }
}

export function mountComponents(instance) {
  if (__DEV__) {
    debug(instance, 'mountComponents', instance.$children);
  }

  Object.values(instance.$children).forEach(function ($child) {
    if (__DEV__) {
      debug(instance, 'mountComponent', $child);
    }

    $child.forEach(mountComponent);
  });
}

function mountOrUpdateComponent(component) {
  if (component instanceof Promise) {
    component.then(function (instance) {
      return instance.$isMounted ? instance.$update() : instance.$mount();
    });
  } else {
    var method = component.$isMounted ? '$update' : '$mount';
    component[method]();
  }
}

export function mountOrUpdateComponents(instance) {
  if (__DEV__) {
    debug(instance, 'mountComponents', instance.$children);
  }

  Object.values(instance.$children).forEach(function ($child) {
    $child.forEach(mountOrUpdateComponent);
  });
}

function destroyComponent(component) {
  if (component instanceof Promise) {
    component.then(function (instance) {
      return instance.$destroy();
    });
  } else {
    component.$destroy();
  }
}

export function destroyComponents(instance) {
  if (__DEV__) {
    debug(instance, 'destroyComponents', instance.$children);
  }

  Object.values(instance.$children).forEach(function ($child) {
    $child.forEach(destroyComponent);
  });
}
//# sourceMappingURL=components.js.map